import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  indent?: 0 | 8 | 20 | 24
  full?: boolean
}

const Indent = ({ children, indent = 8, full = false }: Props) => {
  const indentClass =
    indent == 0
      ? 'pl-0'
      : indent == 8
      ? 'pl-2'
      : indent == 20
      ? 'pl-[20px]'
      : indent == 24
      ? 'pl-6'
      : ''
  return (
    <>
      <div className={clsx(indentClass, full && 'w-full')}>{children}</div>
    </>
  )
}

export default Indent
